function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0,125.541 1.226,111.838 8.687,99.363 21.794,88.174 41.111,77.569 64.791,50.772 70.41,53.909  97.176,37.068 105.933,37.068 107.148,33.97 120.84,18.374 125.222,15.262 128.358,15.262 138.315,30.833 154.521,38.929  154.521,45.171 176.949,75.703 171.933,85.031 176.949,93.14 185.637,96.271 200,108.739 195.631,113.096 195.631,122.442  163.221,139.88 163.221,145.519 160.744,150.484 130.835,178.501 104.663,175.402 58.561,156.708 45.499,154.854 36.742,159.807  32.398,176.66 32.398,184.737 21.794,181.651 5.601,164.176 0,154.854 "
});

var Svg01 = function Svg01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AGS",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/01.3b2b077d.svg";
export { ForwardRef as ReactComponent };